import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AccessControlTab from './AccessControlTab';

const AccessControlRoutes = () => {
  return (
    <Routes>
      {/* Default redirect to users tab */}
      <Route path="" element={<Navigate to="users" replace />} />
      
      {/* Tab-specific routes */}
      <Route path="users" element={<AccessControlTab />} />
      <Route path="login-history" element={<AccessControlTab />} />
      <Route path="roles" element={<AccessControlTab />} />
      <Route path="permissions" element={<AccessControlTab />} />
      
      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="users" replace />} />
    </Routes>
  );
};

export default AccessControlRoutes;
